import React from "react";

/**
 * ProfileImageModal - A reusable modal component for viewing profile images
 * @param {boolean} show - Controls modal visibility
 * @param {function} onClose - Callback to close the modal
 * @param {string} imageUrl - URL of the profile image to display
 */
const ProfileImageModal = ({ show, onClose, imageUrl }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          maxWidth: "400px",
          maxHeight: "400px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            cursor: "pointer",
            fontSize: "24px",
            fontWeight: "bold",
            color: "#666",
          }}
          onClick={onClose}
        >
          ×
        </div>
        <div style={{ textAlign: "center" }}>
          <img
            src={imageUrl}
            alt="Profile"
            style={{
              width: "400px",
              height: "400px",
              borderRadius: "8px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileImageModal;
